import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const ComponentHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: max-content;
  justify-content: space-between;
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 22px;
  align-items: center;
`;
export const SearchBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 250px;
  border-radius: 8px;
  border: solid 1px #ebebeb;
  padding: 12px;
  margin-left: 30px;
  align-items: center;
  justify-content: space-between;
`;
export const SearchInput = styled.input`
  font-size: 16px;
  font-weight: 300;
  text-align: left;
  outline: none;
  border: none;
`;
export const SearchIcon = styled.img`
  height: 13px;
  width: 13px;
`;
export const AddNewButton = styled.button`
  font-family: MuseoSans, serif;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  background-color: #832729;
  color: white;
  white-space: nowrap;
  padding: 11px 14px;
  border: none;
  outline: none;
`;
